
const grupy_maszyn = ['A','R','G','AG','GR', 'HP', 'M']
exports.grupy_maszyn=grupy_maszyn

const grupy_maszyn_flekso = ['A','R','G','AG','GR','M']
exports.grupy_maszyn_flekso=grupy_maszyn_flekso

const grupy_maszyn_all = ['A','G','R','H','S','AG','GR','M','RI','GA','PRA','VIML','NF','HP','FI','LEO','RF1','RF2','JU1','JU2','LE1','LE2','LE3','LE4','JUI','LE5','VPRZ']

const default_grupa_maszyn_for_etap:Record<string, string> = {
    'ETAP_CYFRA':'HP',
    'ETAP_FINISHING':'FI',
    'ETAP_SZTANCOWANIE_IML':'VIML',
    'ETAP_SZTANCOWANIE_BEZ_DRUKU':'LEO',
    'ETAP_NEWFOIL':'NF',
    'ETAP_PRZEWIJARKA':'VPRZ'
}

const grupa_maszyn_arr_for_etap: Record<string, string> = {
    'ETAP_CYFRA': 'H',
    'ETAP_FINISHING': 'F',
    'ETAP_SZTANCOWANIE_IML': 'I',
    'ETAP_SZTANCOWANIE_BEZ_DRUKU': 'S',
    'ETAP_NEWFOIL': 'N',
    'ETAP_PRZEWIJARKA': 'P'
};

const grupy_maszyn_map: Record<string, string>={
    'A':'ARSOMA',
    'R':'RCS',
    'G':'GIDUE',
    'HP':'HP',
    'M':'MARK ANDY HYBRYDA',
    'AG':'ARSOMA/GIDUE',
    'GR':'GIDUE/RCS'
}
exports.grupy_maszyn_map=grupy_maszyn_map

function get_grupa_maszyn_arr(calc:any) {
    console.log("get_grupa_maszyn_arr start1")
    const grupa_maszyn_arr=[]
    for (let i=0;i<calc.etapy.length;i++) {
        const etap=calc.etapy[i];
        let g=''
        if (etap.etap_typ=='ETAP_FLEKSO') {
            if (etap.grupa_maszyn) {
                g=etap.grupa_maszyn;
                //console.log(etap.stat)
                if (etap.stat.kolory) { 
                    g+=etap.stat.kolory;
                } else {
                    g+="0";
                }
            }
        }
        else {
            g=grupa_maszyn_arr_for_etap[etap.etap_typ]
        }

        if (g) grupa_maszyn_arr.push(g)
    }
    return grupa_maszyn_arr
}
exports.get_grupa_maszyn_arr = get_grupa_maszyn_arr


function get_grupa_maszyn(etap:any) {
   
    let grupa_maszyn = etap.grupa_maszyn
    
    if (etap.etap_typ=='ETAP_FLEKSO') {
        if (!grupa_maszyn) return null;
        grupa_maszyn=grupa_maszyn.trim() 

        for (let i=0;i<grupy_maszyn_flekso.length;i++) {
            const g=grupy_maszyn_flekso[i]
            if (etap.grupa_maszyn==g && !etap.stat[g]) etap.grupa_maszyn=null;
        }
    }
    else grupa_maszyn=default_grupa_maszyn_for_etap[etap.etap_typ]

    return grupa_maszyn
}
exports.get_grupa_maszyn = get_grupa_maszyn


function get_etap_grupy_maszyn(etap:any) {
    const grupy_maszyn=[]
    for (let i=0;i<grupy_maszyn_all.length;i++) {
        const g=grupy_maszyn_all[i]
        if (etap.stat[g] ) {
            grupy_maszyn.push(g)
        } 
    }
    return grupy_maszyn
}
exports.get_etap_grupy_maszyn = get_etap_grupy_maszyn


function get_etap_predkosc(etap:any) {
    let predkosc=33
    if (etap.grupa_maszyn=='A') predkosc=etap.stat.predkosc_A;
    if (etap.grupa_maszyn=='G') predkosc=etap.stat.predkosc_G;
    if (etap.grupa_maszyn=='R') predkosc=etap.stat.predkosc_R;
    if (etap.grupa_maszyn=='M') predkosc=etap.stat.predkosc_M;
    if (etap.grupa_maszyn=='AG') predkosc=Math.min(etap.stat.predkosc_A, etap.stat.predkosc_G);
    if (etap.grupa_maszyn=='GR') predkosc=Math.min(etap.stat.predkosc_G, etap.stat.predkosc_R);
    if (etap.grupa_maszyn=='HP') predkosc=get_predkosc_cyfra(etap)

    return predkosc;
}
exports.get_etap_predkosc = get_etap_predkosc

function get_cena_bazowa_papier(grp:string) {
    let cena_bazowa_papier=65;
    if(grp=='H') cena_bazowa_papier =65
    if(grp=='A') cena_bazowa_papier =130
    if(grp=='M') cena_bazowa_papier =130
    if(grp=='R') cena_bazowa_papier =217
    if(grp=='G') cena_bazowa_papier =217
    if(grp=='AG') cena_bazowa_papier=217
    if(grp=='GR') cena_bazowa_papier=217
    return cena_bazowa_papier;
}
exports.get_cena_bazowa_papier = get_cena_bazowa_papier

function get_cena_bazowa_folia(grp:string) {
    let cena_bazowa_folia=65;
    if(grp=='H') cena_bazowa_folia  =65
    if(grp=='A') cena_bazowa_folia  =173
    if(grp=='M') cena_bazowa_folia =173
    if(grp=='R') cena_bazowa_folia  =217
    if(grp=='G') cena_bazowa_folia  =217
    if(grp=='AG') cena_bazowa_folia=217
    if(grp=='GR') cena_bazowa_folia=217
    return cena_bazowa_folia;

}
exports.get_cena_bazowa_folia = get_cena_bazowa_folia


function get_predkosc_cyfra(etap:any) {
    if (!(etap.etap_typ=='ETAP_CYFRA')) return 0;

    let count=0;
    for (let i=0;i<etap.technologie.length;i++) {
        const t=etap.technologie[i]
        if (!(t.typ=='start zlecenia')) count++;
    }
    if (!count) return 120;

    const maxPredkoscDruku = 120;    
    let predkoscDruku = maxPredkoscDruku / count;
	if (count == 1) predkoscDruku = 60;
	if (count == 2) predkoscDruku = 60;
	if (count == 3) predkoscDruku = 40;

    return predkoscDruku;
}
exports.get_predkosc_cyfra = get_predkosc_cyfra

function create_select_grupy_maszyn_stat(technologia_table:any, etap_id:string) {
let s=`
select t.e_id as ee_id,  0 as predkosc, 
0 as cena_mkw, 
null as zeby, 
null as szerokosci, 
min(COALESCE(m.technologia,'')) as title, 
sum(COALESCE(m.czas_na_ux,0)) as czas_na_ux, 
sum(m.czas_przyg) as czas_przyg, 
sum(m.czas_przyg_M) as czas_przyg_M, 
sum(m.odpad) as odpad,
min(COALESCE(m.predkosc_A,111)) as predkosc_A, 
min(COALESCE(m.predkosc_G,111)) as predkosc_G, 
min(COALESCE(m.predkosc_R,111)) as predkosc_R,
min(COALESCE(m.predkosc_M,111)) as predkosc_M,
min(m.A) as A,	
min(m.G) as G,	
min(m.R) as R,	
min(m.AG) as AG,
min(m.GR) as GR,
min(m.M) as M,
min(m.A3) as A3,	
min(m.A4) as A4,	
min(m.A5) as A5,	
min(m.A6) as A6,	
min(m.A7) as A7,	
min(m.R1) as R1,	
min(m.R2) as R2,	
min(m.R3) as R3,		
min(m.R5) as R5,	
min(m.RI) as RI,	
min(m.GA) as GA,	
min(m.NF) as NF,	
min(m.HP) as HP,	
min(m.FI) as FI,	
min(m.RF1) as RF1,	
min(m.RF2) as RF2,	
min(m.JU1) as JU1,	
min(m.JU2) as JU2,	
min(m.LE1) as LE1,	
min(m.LE2) as LE2,	
min(m.LE3) as LE3,	
min(m.LE4) as LE4,	
min(m.JUI) as JUI,	
min(m.LE5) as LE5,
min(m.VPRZ) as VPRZ 
 from TTTT
 t LEFT OUTER join maszyny m on 
 (t.etap_typ=m.etap and (t.typ=m.technologia)) 
 where (t.e_id=XXX and not COALESCE(t.typ,'')='') group by t.e_id;
`
s=s.replace('TTTT', technologia_table)
s=s.replace('XXX', etap_id);		

return s
}
exports.create_select_grupy_maszyn_stat = create_select_grupy_maszyn_stat

function get_alalib_tech_sql(tree_table_name:string) {
    let s=` select t.*, t.komponent_szerokosc, 
    m.kolor,
    m.czas_przyg,
    m.czas_przyg_M,

    m.odpad,
    m.odpad_M,
    m.predkosc_A,
    m.predkosc_G,
    m.predkosc_R,
    m.predkosc_AG,
    m.predkosc_GR, 
    75 as predkosc_M
    `
    s+=" from "+tree_table_name+" t LEFT OUTER join maszyny m on "
    s+=" (t.etap_typ=m.etap and t.typ=m.technologia) "
    return s
}
exports.get_alalib_tech_sql=get_alalib_tech_sql


function alalib_params1_sql(tech_table_name:string) {
    let s1=""
    s1=`select t.etap_typ, t.typ, t.etap_grupa_maszyn, 
    CASE WHEN (t.etap_grupa_maszyn='A') THEN m.A ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='G') THEN m.G ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='R') THEN m.R ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='AG') THEN m.AG ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='M') THEN m.M ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='GR') THEN m.GR ELSE 0 END
    as x,
    m.A, m.G, m.R, m.AG, m.GR, m.M, m.etap as param
    `
    s1+=" from "+tech_table_name+" t LEFT OUTER join maszyny m on "
    s1+=" (t.typ=m.technologia) "
    s1+=" where m.etap LIKE 'PARAM_STRATY_NA_ROLKE_DODAJ'"
    return s1
}
exports.alalib_params1_sql=alalib_params1_sql

function alalib_params2_sql(tech_table_name:string) {
    let s2=""
    s2=`select  distinct (t.etap_typ) as etap_typ,'na_rolke' as typ, 
    t.etap_grupa_maszyn, 
    CASE WHEN (t.etap_grupa_maszyn='A') THEN m.A ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='G') THEN m.G ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='R') THEN m.R ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='AG') THEN m.AG ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='GR') THEN m.GR ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='M') THEN m.M ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='HP') THEN m.H ELSE 0 END
    as x,
    m.A, m.G, m.R, m.AG, m.GR, m.H, m.M, 
    m.etap as param
    `
    s2+=" from "+tech_table_name+" t LEFT OUTER join maszyny m on "
    s2+=" (t.etap_typ like 'ETAP_%') " // true
    s2+=" where m.etap = 'PARAM_STRATY_NA_ROLKE'"
    return s2
}
exports.alalib_params2_sql=alalib_params2_sql


function alalib_predkosc_sql(tech_table_name:string) {
    let s1=""
    s1=`select t.etap_id, t.etap_typ, t.typ, t.etap_grupa_maszyn, 

    CASE WHEN (t.etap_grupa_maszyn='A')  THEN COALESCE(m.predkosc_A ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='G')  THEN COALESCE(m.predkosc_G ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='R')  THEN COALESCE(m.predkosc_R ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='AG') THEN COALESCE(m.predkosc_AG,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='M') THEN 75 ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='GR') THEN COALESCE(m.predkosc_GR,0) ELSE 0 END
    as predkosc 
    `
    s1+=" from "+tech_table_name+" t LEFT OUTER join maszyny m on "
    s1+=" (t.typ=m.technologia and t.etap_typ=m.etap) "
    return s1
}
exports.alalib_predkosc_sql=alalib_predkosc_sql


function alalib_koszt_siatek_sql(tech_table_name:string,siatki_table_name:string,tylko_zmiana:number) {
    let s1 = ""
    s1+="select t.etap_typ, t.typ, t.etap_grupa_maszyn, s.A, s.G, s.R, s.M, s.AG, s.GR, t.zmiana, "  
    s1+=`
    CASE WHEN (t.etap_grupa_maszyn='A')  THEN COALESCE(s.A ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='G')  THEN COALESCE(s.G ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='R')  THEN COALESCE(s.R ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='M)  THEN COALESCE(s.M ,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='AG') THEN COALESCE(s.AG,0) ELSE 0 END+
    CASE WHEN (t.etap_grupa_maszyn='GR') THEN COALESCE(s.GR,0) ELSE 0 END
    as koszt_siatek 
    `
    s1+=" from "+tech_table_name+" t "
    s1+=" join "+siatki_table_name+' s on rtrim(s.technologia) = rtrim(t.typ) '
    s1+=" where (t.typ = 'sito' or t.typ = 'sito puchn') "
    if (tylko_zmiana) {   s1+= " and zmiana=TRUE "   }

    return s1
}
exports.alalib_koszt_siatek_sql=alalib_koszt_siatek_sql